import { FilterItemButton } from './filter-item-button'
import { SidebarFilterSection } from './sidebar-filter-section'
import { useFilterContext } from '../../context/filter-context'
import { WorkoutDuration } from '../../dao/core-dao'
import { useWorkoutDurations } from '../../hook/use-workouts'
import React, { useMemo } from 'react'

export const DurationFilter = (): React.ReactElement => {
  const { workoutFilter, toggleFilterEntry } = useFilterContext()
  const { data: allDurations = [] } = useWorkoutDurations()

  const availableDurations = useMemo(() => {
    return allDurations.filter((duration) => duration.isFilterable)
  }, [allDurations])

  const handleToggleSelectedDuration = ({ id }: WorkoutDuration): void => {
    toggleFilterEntry('durations', id)
  }

  const renderDuration = (duration: WorkoutDuration, additionalClass?: string): React.ReactElement => {
    const isActive = workoutFilter?.durations?.includes(duration.id) ?? false
    return (
      <FilterItemButton
        className={additionalClass}
        fullWidth={true}
        onClick={() => handleToggleSelectedDuration(duration)}
        isActive={isActive}
      >
        <span className="font-evogria text-2xl leading-8 text-light-gray">{duration.durationValue}</span>
        <span className="font-roboto text-sm leading-5 tracking-[0.25px] text-light-gray">min</span>
      </FilterItemButton>
    )
  }
  return <SidebarFilterSection title={'Duration'} items={availableDurations} renderItem={renderDuration} />
}
